import React__default from 'react';
import { useStyles, useKeyPress, useMergedRef } from '@sravni/react-utils';
import { Tag } from '../../Tag/src/Tag.js';
import { useOptionsMap } from '../hooks/useOptionsMap.js';
import modules_89c5f6c6 from '../styles/TagModeView.module.less.js';

const TagModeView = React__default.forwardRef((props, ref) => {
    const { value, options, focused, fixedHeight, inputRef, menuRef, onSetValue, onSetOptions, onChangeInput, onFocus, onBlur, onSelect, ...restProps } = props;
    const [tagInputValue, setTagInputValue] = React__default.useState('');
    const containerRef = React__default.useRef(null);
    const cx = useStyles(modules_89c5f6c6);
    const getOptionByValue = useOptionsMap(options);
    const containerClassnames = cx('container', {
        focused,
        [`fixed-height`]: fixedHeight,
    });
    const inputClassnames = cx('input', {
        focused,
    });
    const tagClassnames = React__default.useCallback((val) => {
        const { tagColor, tagVariant = 'secondary' } = getOptionByValue(val);
        return cx('tag', {
            [`color-${tagColor}-${tagVariant}`]: true,
        });
    }, [cx, getOptionByValue]);
    const setInitialState = React__default.useCallback(() => {
        // очищаем ранее введенный текст
        setTagInputValue('');
        // делаем минимальную ширину пустого инпута, чтобы он мог расположится на одной строке с тэгами, а не был на новой строке
        inputRef.current.style.width = `10px`;
    }, [inputRef]);
    const handleChangeInput = (event) => {
        onChangeInput(event);
        setTagInputValue(event.currentTarget.value);
        // меняем ширину инпута под размер введенного текста
        inputRef.current.style.width = `${inputRef.current?.scrollWidth}px`;
    };
    const handleBlurContainer = (event) => {
        // если событие блюра происходит в результате фокуса не меню (например, outside клик )
        if (!menuRef.current?.contains(event.relatedTarget)) {
            onSetOptions(options);
            setInitialState();
        }
        onBlur?.(event);
    };
    const handleFocusContainer = (event) => {
        event.stopPropagation();
        event.preventDefault();
        onFocus?.(event);
        // перевод фокуса на инпут для ввода (по событию фокуса на контейнере)
        inputRef.current?.focus();
    };
    const handleCloseTag = (e, val) => {
        // чтобы закрытие тэга не приводило к закрытию меню (списка опций), НО! ломает некоторое поведение в самом автокомплите
        e.stopPropagation();
        // устанавливаем опции без фильтрации
        onSetOptions(options);
        // устанавливаем новое значение innerValue автокомплита и выполняем колбэк
        const newValue = value?.filter((currentValue) => currentValue !== val);
        onSetValue(newValue);
        onSelect?.(newValue);
    };
    useKeyPress({
        // удаляем по Backspace тэг перед курсором
        enabled: focused,
        keyMap: {
            Backspace: (event) => {
                if (event.target.value === '') {
                    onSetValue(value?.slice(0, -1));
                }
            },
        },
    }, [value, onSetValue]);
    React__default.useEffect(() => {
        // устанавливаем начальные значения при изменении value (например, клик по menuItem)
        setInitialState();
        // устанавливаем опции в автокомполите без фильтрации (когда ничего не введено)
        onSetOptions(options);
    }, [value, onSetOptions, options, setInitialState]);
    return (React__default.createElement("div", { ref: useMergedRef(ref, containerRef), className: containerClassnames, tabIndex: -1, onFocus: handleFocusContainer, onBlur: handleBlurContainer },
        Array.isArray(value) &&
            value.map((val) => (React__default.createElement(Tag, { key: val, className: tagClassnames(val), size: 36, closable: true, onClose: (event) => handleCloseTag(event, val) },
                React__default.createElement("span", { className: modules_89c5f6c6['tag-text'] }, getOptionByValue(val).label)))),
        React__default.createElement("input", { ...restProps, ref: inputRef, 
            // начальная ширина пустого инпута для корректного отображения компонента
            style: { width: '10px' }, className: inputClassnames, value: tagInputValue, onChange: handleChangeInput })));
});

export { TagModeView };
//# sourceMappingURL=TagModeView.js.map
